"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _preactCompat = require("preact-compat");

var _Loading = _interopRequireDefault(require("./Loading"));

var _SearchSmartSummaryService = _interopRequireDefault(require("../../../services/SearchSmartSummary/SearchSmartSummaryService"));

var _connectors = require("@insided/shared/services/algolia/connectors");

var _Sources = _interopRequireDefault(require("./Sources"));

var _SearchService = _interopRequireDefault(require("../../../services/SearchService"));

var _marked = require("marked");

var _utils = require("./utils");

var _Feedback = require("@insided/shared/modules/HubAI/Feedback");

var _utils2 = require("../../../utils");

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

var _AIAnswersHeader = _interopRequireDefault(require("./AIAnswersHeader"));

var _globals2 = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var communityId = (0, _utils2.getCommunityId)();

var SmartSearchSummary = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(SmartSearchSummary, _PureComponent);

  var _super = _createSuper(SmartSearchSummary);

  function SmartSearchSummary() {
    var _this;

    (0, _classCallCheck2.default)(this, SmartSearchSummary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "abortController", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isMounted", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "readTimeInitiated", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "readTimeSetupStarted", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      loading: false,
      sourcesLength: 0,
      sourcesLoading: false,
      topicIds: [],
      documentIds: [],
      isExpanded: false,
      generatedForQuery: undefined,
      showAllResources: false,
      impressionTracked: false,
      contentVisibleAt: null,
      readTimeTimerId: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleExpanded", function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      }); // Track "Continue reading" click when expanding


      _this.trackAIAnswersEvent('AI Answers Continue Reading Clicked', 'continueReading'); // Trigger impression on continue reading


      _this.trackImpression('continue_reading');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onGenerateClick", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _searchState$query;

      var _this$props, askAISearchSummary, searchState;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, askAISearchSummary = _this$props.askAISearchSummary, searchState = _this$props.searchState; // Don't generate if there's no query

              if ((_searchState$query = searchState.query) !== null && _searchState$query !== void 0 && _searchState$query.trim()) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              // Track "Generate Summary" click
              _this.trackAIAnswersEvent('AI Answers Generate Summary Clicked', 'generateSummary');

              if (askAISearchSummary) {
                _this.getAskAISearchSummary();
              } else {
                _this.getSmartSummary();
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "trackAIAnswersEvent", function (eventType, elementName) {
      var _searchState$query2;

      var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var searchState = _this.props.searchState;

      _publish.default.trackEvent('userevent', _objectSpread({
        type: eventType,
        boundedContext: 'Search',
        entity: 'ai-answers',
        elementName: elementName,
        eventDetail: "search.ai-answers.".concat(elementName),
        trackType: 'click',
        searchQuery: (_searchState$query2 = searchState.query) !== null && _searchState$query2 !== void 0 ? _searchState$query2 : ''
      }, extraProps));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "trackImpression", function (reason) {
      var _searchState$query3;

      // Don't track if already tracked in this session
      if (_this.state.impressionTracked) {
        return;
      }

      var searchState = _this.props.searchState;
      var contentVisibleAt = _this.state.contentVisibleAt; // Calculate read time ONLY for read_time impressions

      var readTimeSeconds;

      if (reason === 'read_time' && contentVisibleAt !== null) {
        readTimeSeconds = Math.round((Date.now() - contentVisibleAt) / 1000).toString();
      }

      var trackingPayload = {
        type: 'AI Answers Impression',
        boundedContext: 'Search',
        entity: 'ai-answers',
        elementName: 'aiAnswersImpression',
        eventDetail: 'search.ai-answers.impression',
        trackType: 'impression',
        searchQuery: (_searchState$query3 = searchState.query) !== null && _searchState$query3 !== void 0 ? _searchState$query3 : '',
        impressionReason: reason
      }; // Only add readTimeSeconds if it's a read_time impression

      if (readTimeSeconds !== undefined) {
        trackingPayload.readTimeSeconds = readTimeSeconds;
      }

      _publish.default.trackEvent('userevent', trackingPayload); // Mark impression as tracked


      _this.setState({
        impressionTracked: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setupReadTimeTracking", function () {
      // Find the content element to observe
      var contentElement = document.querySelector('.answer-content') || document.querySelector('.ai-answer');

      if (!contentElement) {
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // Content is now visible in viewport
            // Prevent multiple timer initiations via race condition
            if (!_this.readTimeInitiated && !_this.state.contentVisibleAt) {
              _this.readTimeInitiated = true;
              var visibleAt = Date.now(); // Set timer to check after 15 seconds and batch state updates

              var timerId = window.setTimeout(function () {
                // Check if component is still mounted before calling setState
                if (_this.isMounted) {
                  _this.onReadTimeComplete();
                }
              }, 10000); // Batch setState call to avoid multiple renders

              _this.setState({
                contentVisibleAt: visibleAt,
                readTimeTimerId: timerId
              });
            } // Disconnect observer after first intersection


            observer.disconnect();
          }
        });
      }, {
        threshold: 0.5
      });
      observer.observe(contentElement) // Store observer reference for cleanup
      ;
      (0, _assertThisInitialized2.default)(_this).readTimeObserver = observer;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onReadTimeComplete", function () {
      _this.trackImpression('read_time');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cleanupReadTimeTracking", function () {
      // Reset only the initiated flag (NOT setupStarted - that controls setup frequency)
      _this.readTimeInitiated = false; // Clear timer if exists

      if (_this.state.readTimeTimerId) {
        window.clearTimeout(_this.state.readTimeTimerId);
      } // Disconnect observer if exists


      var observer = (0, _assertThisInitialized2.default)(_this).readTimeObserver;

      if (observer) {
        observer.disconnect();
        (0, _assertThisInitialized2.default)(_this).readTimeObserver = null;
      } // Reset state only if still mounted


      if (_this.isMounted) {
        _this.setState({
          contentVisibleAt: null,
          readTimeTimerId: null
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "trackShowAllResourcesClick", function () {
      var _searchState$query4;

      var searchState = _this.props.searchState;

      _publish.default.trackEvent('userevent', {
        type: 'AI Answers Show All Resources Clicked',
        boundedContext: 'Search',
        entity: 'ai-answers',
        elementName: 'showAllResources',
        eventDetail: 'search.ai-answers.showAllResources',
        trackType: 'click',
        searchQuery: (_searchState$query4 = searchState.query) !== null && _searchState$query4 !== void 0 ? _searchState$query4 : ''
      }); // Trigger impression on show all click


      _this.trackImpression('show_all_click');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFeedbackClick", function (e) {
      var target = e.target;
      var button = target.closest('.feedback--button__like, .feedback--button__dislike');

      if (button !== null && button !== void 0 && button.classList.contains('feedback--button__like')) {
        _this.onFeedbackLike();
      } else if (button !== null && button !== void 0 && button.classList.contains('feedback--button__dislike')) {
        _this.onFeedbackDislike();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFeedbackLike", function () {
      _this.trackAIAnswersEvent('AI Answers Feedback Upvote', 'feedbackUpvote');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFeedbackDislike", function () {
      _this.trackAIAnswersEvent('AI Answers Feedback Downvote', 'feedbackDownvote');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAskAISearchSummary", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var searchState, question, currentQuery, _response$body, payload, response, _errorData$rateLimit, errorData, resetInSeconds, resetInHours, errorText, reader, decoder, fullResponse, conversationalText, buffer, chunkCount, _lines$pop, _yield$reader$read, done, value, chunk, lines, _iterator, _step, line, trimmedLine, data, parsed, colonIndex, prefix, content, text, formattedHTML, _toolResult$result, _toolResult$result$hi, toolResult, _response;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              searchState = _this.props.searchState;
              question = searchState.query;

              if (question) {
                _context2.next = 5;
                break;
              }

              console.error('[AskAI] Error: No search query provided');
              return _context2.abrupt("return");

            case 5:
              // Store the query we're generating for
              currentQuery = question;

              _this.setState({
                loading: true
              }); // Create a new AbortController for this request


              _this.abortController = new AbortController();
              _context2.prev = 8;
              // SECURITY: Only send searchTerm to backend
              // Backend generates secured API key and filters based on user permissions
              payload = {
                searchTerm: question
              }; // Debug: Print complete payload
              // console.log('[AskAI] Complete payload being sent to backend:', JSON.stringify(payload, null, 2))
              // console.log('[AskAI] Payload details:', {
              //   searchTerm: payload.searchTerm,
              //   searchFilters: payload.searchFilters,
              //   apiKey: payload.apiKey,
              //   communityId: payload.communityId
              // })

              _context2.next = 12;
              return fetch((0, _absoluteUrlRuntime.resolveUrl)('/search/askAISearchSummary'), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'text/event-stream',
                  'X-CSRF-Token': (0, _csrfToken.csrfToken)() // Include CSRF token

                },
                body: JSON.stringify(payload),
                signal: _this.abortController.signal // Add abort signal

              });

            case 12:
              response = _context2.sent;

              if (response.ok) {
                _context2.next = 41;
                break;
              }

              console.error('[AskAI] Error: Request failed with status', response.status); // Handle rate limit error specially

              if (!(response.status === 429)) {
                _context2.next = 30;
                break;
              }

              _context2.prev = 16;
              _context2.next = 19;
              return response.json();

            case 19:
              errorData = _context2.sent;
              resetInSeconds = (_errorData$rateLimit = errorData.rateLimit) === null || _errorData$rateLimit === void 0 ? void 0 : _errorData$rateLimit.resetIn;

              if (resetInSeconds) {
                resetInHours = Math.ceil(resetInSeconds / 3600);

                _this.setState({
                  error: "Whoa there \u2014 you've maxed out your AI answers! Hang tight, your quota will reset in ".concat(resetInHours, " ").concat(resetInHours === 1 ? 'hour' : 'hours', "."),
                  loading: false
                });
              } else {
                _this.setState({
                  error: "Whoa there — you've maxed out your AI answers! Hang tight, your quota will reset soon.",
                  loading: false
                });
              }

              return _context2.abrupt("return");

            case 25:
              _context2.prev = 25;
              _context2.t0 = _context2["catch"](16);
              console.error('[AskAI] Could not parse rate limit error:', _context2.t0);

              _this.setState({
                error: "Whoa there — you've maxed out your AI answers! Hang tight, your quota will reset soon.",
                loading: false
              });

              return _context2.abrupt("return");

            case 30:
              _context2.prev = 30;
              _context2.next = 33;
              return response.text();

            case 33:
              errorText = _context2.sent;
              console.error('[AskAI] Error response body:', errorText);
              _context2.next = 40;
              break;

            case 37:
              _context2.prev = 37;
              _context2.t1 = _context2["catch"](30);
              console.error('[AskAI] Could not read error response body:', _context2.t1);

            case 40:
              throw new Error("Request failed: ".concat(response.status));

            case 41:
              // Process SSE stream from backend
              reader = (_response$body = response.body) === null || _response$body === void 0 ? void 0 : _response$body.getReader();
              decoder = new TextDecoder();
              fullResponse = '';
              conversationalText = '';
              buffer = ''; // Buffer for incomplete lines

              if (reader) {
                _context2.next = 50;
                break;
              }

              console.error('[AskAI] Error: No reader available from response body');

              _this.setState({
                error: 'Failed to read stream',
                loading: false
              });

              return _context2.abrupt("return");

            case 50:
              chunkCount = 0;

              if (!reader) {
                _context2.next = 108;
                break;
              }

            case 52:
              if (!true) {
                _context2.next = 108;
                break;
              }

              _context2.next = 55;
              return reader.read();

            case 55:
              _yield$reader$read = _context2.sent;
              done = _yield$reader$read.done;
              value = _yield$reader$read.value;
              chunkCount++;

              if (!done) {
                _context2.next = 61;
                break;
              }

              return _context2.abrupt("break", 108);

            case 61:
              // Decode chunk and add to buffer
              chunk = decoder.decode(value, {
                stream: true
              });
              buffer += chunk; // Process complete lines from buffer

              lines = buffer.split('\n'); // Keep the last incomplete line in the buffer

              buffer = (_lines$pop = lines.pop()) !== null && _lines$pop !== void 0 ? _lines$pop : '';
              _iterator = _createForOfIteratorHelper(lines);
              _context2.prev = 66;

              _iterator.s();

            case 68:
              if ((_step = _iterator.n()).done) {
                _context2.next = 98;
                break;
              }

              line = _step.value;
              trimmedLine = line.trim(); // Skip empty lines and SSE comments

              if (!(!trimmedLine || trimmedLine.startsWith(':'))) {
                _context2.next = 73;
                break;
              }

              return _context2.abrupt("continue", 96);

            case 73:
              _context2.prev = 73;

              if (!trimmedLine.startsWith('data: ')) {
                _context2.next = 90;
                break;
              }

              data = trimmedLine.slice(6).trim();

              if (data) {
                _context2.next = 78;
                break;
              }

              return _context2.abrupt("continue", 96);

            case 78:
              parsed = JSON.parse(data); // Handle backend-specific events (connection, error, close)

              if (!(parsed.type === 'connection')) {
                _context2.next = 82;
                break;
              }

              _context2.next = 89;
              break;

            case 82:
              if (!(parsed.type === 'error')) {
                _context2.next = 88;
                break;
              }

              console.error('[AskAI] Server error event:', parsed.error);

              _this.setState({
                error: parsed.error || 'Failed to get AI summary',
                loading: false
              });

              return _context2.abrupt("return");

            case 88:
              if (parsed.type === 'close') {// Stream closed
              }

            case 89:
              return _context2.abrupt("continue", 96);

            case 90:
              // Handle Algolia's custom format (prefixed events)
              if (trimmedLine.includes(':')) {
                colonIndex = trimmedLine.indexOf(':');
                prefix = trimmedLine.substring(0, colonIndex);
                content = trimmedLine.substring(colonIndex + 1); // Handle conversational text chunks (0:"text")

                if (prefix === '0') {
                  text = JSON.parse(content);
                  conversationalText += text; // Parse Markdown to HTML and update UI in real-time

                  formattedHTML = _marked.marked.parse(conversationalText); // Update UI with streaming text (keep loading: true until stream completes)

                  _this.setState({
                    data: "<div class=\"conversational-text\">".concat(formattedHTML, "</div>"),
                    generatedForQuery: currentQuery
                  });
                } // Handle tool results with search hits (a:{...})
                else if (prefix === 'a') {
                  toolResult = JSON.parse(content);

                  if (((_toolResult$result = toolResult.result) === null || _toolResult$result === void 0 ? void 0 : (_toolResult$result$hi = _toolResult$result.hits) === null || _toolResult$result$hi === void 0 ? void 0 : _toolResult$result$hi.length) > 0) {
                    toolResult.result.hits.forEach(function (hit) {
                      var _globals;

                      fullResponse += "<div class=\"resource-card\">"; // Add title
                      // For hub app, prefer content_url (absolute URLs)
                      // For forum/control apps, prefer topic_url (relative URLs)

                      var isHub = ((_globals = (0, _globals2.default)('appState')) === null || _globals === void 0 ? void 0 : _globals.appName) === 'hub';
                      var hitUrl = isHub ? hit.url || hit.content_url || hit.topic_url : hit.url || hit.topic_url || hit.content_url;

                      if (hit.title && hitUrl) {
                        fullResponse += "<h4><a href=\"".concat(hitUrl, "\" target=\"_blank\">").concat(hit.title, "</a></h4>");
                      } else if (hit.title) {
                        fullResponse += "<h4>".concat(hit.title, "</h4>");
                      } // Add description/excerpt if available


                      if (hit.content || hit.reply || hit.first_post) {
                        var description = hit.content || hit.reply || hit.first_post; // Strip HTML tags first

                        var cleanText = description.replace(/<[^>]*>/g, '').trim(); // Replace multiple whitespaces/newlines with single space

                        var singleLineText = cleanText.replace(/\s+/g, ' '); // Truncate to ~100 characters

                        var truncatedDesc = singleLineText.length > 100 ? singleLineText.substring(0, 100).trim() + '...' : singleLineText;
                        fullResponse += "<p class=\"resource-description\">".concat(truncatedDesc, "</p>");
                      }

                      fullResponse += "</div>";
                    });
                  }
                } // Handle other event types (9: tool calls, f: frames, e: completion, d: done)
                else if (prefix === '9') {// Tool call event
                } else if (prefix === 'f') {// Frame event
                } else if (prefix === 'e') {// Completion event
                } else if (prefix === 'd') {// Done event
                }
              }

              _context2.next = 96;
              break;

            case 93:
              _context2.prev = 93;
              _context2.t2 = _context2["catch"](73);
              console.error('[AskAI] Parse error:', _context2.t2, 'Line:', trimmedLine); // Don't show parse errors to user, just log them

            case 96:
              _context2.next = 68;
              break;

            case 98:
              _context2.next = 103;
              break;

            case 100:
              _context2.prev = 100;
              _context2.t3 = _context2["catch"](66);

              _iterator.e(_context2.t3);

            case 103:
              _context2.prev = 103;

              _iterator.f();

              return _context2.finish(103);

            case 106:
              _context2.next = 52;
              break;

            case 108:
              // Process any remaining data in buffer
              if (buffer.trim()) {// Remaining buffer data exists
              } // Final state update with complete response


              if (conversationalText || fullResponse) {
                _response = SmartSearchSummary.formatResponse(conversationalText, fullResponse);

                _this.setState({
                  data: _response.conversationalText,
                  resources: _response.resources,
                  loading: false,
                  generatedForQuery: currentQuery
                });
              } else {
                _this.setState({
                  error: 'No response received, better luck next time.',
                  loading: false
                });
              }

              _context2.next = 122;
              break;

            case 112:
              _context2.prev = 112;
              _context2.t4 = _context2["catch"](8);

              if (!(_context2.t4 instanceof Error && _context2.t4.name === 'AbortError')) {
                _context2.next = 117;
                break;
              }

              /* 
                eslint-disable-next-line no-console 
                */
              console.log('[AskAI] Request aborted due to query change');
              return _context2.abrupt("return");

            case 117:
              console.error('[AskAI] FATAL ERROR in getAskAISearchSummary:', _context2.t4);
              console.error('[AskAI] Error stack:', _context2.t4 instanceof Error ? _context2.t4.stack : 'No stack trace');
              console.error('[AskAI] Error name:', _context2.t4 instanceof Error ? _context2.t4.name : 'Unknown');
              console.error('[AskAI] Error message:', _context2.t4 instanceof Error ? _context2.t4.message : String(_context2.t4));

              _this.setState({
                error: 'Failed to get AI summary. Please try again.',
                loading: false
              });

            case 122:
              _context2.prev = 122;
              // Clean up the abort controller
              _this.abortController = null;
              return _context2.finish(122);

            case 125:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 112, 122, 125], [16, 25], [30, 37], [66, 100, 103, 106], [73, 93]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSmartSummary", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var searchState, searchTerm, indexTopicIdsMap, res;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              searchState = _this.props.searchState;
              searchTerm = searchState.query;

              if (searchTerm) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return");

            case 4:
              indexTopicIdsMap = (0, _utils.getIndexTopicIdsMap)(_this.props.allSearchResults);

              if (indexTopicIdsMap) {
                _context3.next = 8;
                break;
              }

              _this.setState({
                error: 'no topics found in search results'
              });

              return _context3.abrupt("return");

            case 8:
              _this.setState({
                loading: true
              });

              _context3.next = 11;
              return _SearchSmartSummaryService.default.getSmartSummary(_this.getUnifiedIndexPayload(), true);

            case 11:
              res = _context3.sent;

              _this.setState({
                loading: false
              });

              if (res) {
                _this.processResponse(res);
              }

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getUnifiedIndexPayload", function () {
      var searchResults = _this.props.searchResults; // Group search results by gs_data_source

      var gsDataSourceMap = searchResults.hits.reduce(function (acc, result) {
        if (!result.gs_data_source) {
          return acc;
        }

        if (!acc[result.gs_data_source]) {
          acc[result.gs_data_source] = [];
        }

        acc[result.gs_data_source].push(result);
        return acc;
      }, {});
      var queries = Object.keys(gsDataSourceMap).map(function (gsDataSource) {
        return {
          indexName: communityId,
          gsDataSource: gsDataSource,
          ids: gsDataSourceMap[gsDataSource].map(function (hit) {
            if ((0, _utils2.isUnifiedCommunityHit)(hit)) {
              return hit.id;
            }

            return hit.objectID;
          })
        };
      });
      return {
        searchTerm: _this.props.searchState.query,
        queries: queries
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleLinkClick", function (eventType, elementName, impressionReason) {
      return function (event) {
        var target = event.target;
        var link = target.closest('a');

        if (link) {
          var _link$getAttribute, _link$textContent;

          var url = (_link$getAttribute = link.getAttribute('href')) !== null && _link$getAttribute !== void 0 ? _link$getAttribute : '';
          var title = (_link$textContent = link.textContent) !== null && _link$textContent !== void 0 ? _link$textContent : '';

          _this.trackAIAnswersEvent(eventType, elementName, {
            sourceUrl: url,
            sourceTitle: title
          }); // Trigger impression on link click


          if (impressionReason) {
            _this.trackImpression(impressionReason);
          }
        }
      };
    });
    return _this;
  }

  (0, _createClass2.default)(SmartSearchSummary, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(previousProps) {
        var _searchSmartSummarySe, _this$state, data, generatedForQuery, searchState, hasVisibleContent;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(previousProps.searchState.query !== this.props.searchState.query)) {
                  _context4.next = 8;
                  break;
                }

                // Clean up previous impression tracking before resetting state
                this.cleanupReadTimeTracking(); // Reset the initiated flag for new query

                this.readTimeInitiated = false; // Reset setup started flag for new query

                this.readTimeSetupStarted = false;
                this.setState({
                  data: undefined,
                  resources: undefined,
                  error: undefined,
                  isExpanded: false,
                  generatedForQuery: undefined,
                  showAllResources: false,
                  impressionTracked: false,
                  contentVisibleAt: null,
                  readTimeTimerId: null
                }); // Cancel ongoing API calls when query changes

                if (this.state.loading) {
                  this.setState({
                    loading: false
                  }); // Cancel fetch request for AI mode (AbortController)

                  if (this.abortController) {
                    this.abortController.abort();
                    this.abortController = null;
                  } // Cancel axios request for non-AI mode


                  (_searchSmartSummarySe = _SearchSmartSummaryService.default.cancelToken) === null || _searchSmartSummarySe === void 0 ? void 0 : _searchSmartSummarySe.cancel();
                } // Don't proceed with automatic summary if query was cleared


                if (this.props.searchState.query) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return");

              case 8:
                if (!(!previousProps.allSearchResults && this.props.allSearchResults)) {
                  _context4.next = 13;
                  break;
                }

                if (!(!_SearchSmartSummaryService.default.firstAutomaticSummaryPerformed && this.props.searchState.query)) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 12;
                return this.onGenerateClick();

              case 12:
                _SearchSmartSummaryService.default.firstAutomaticSummaryPerformed = true;

              case 13:
                // Setup read time tracking when content appears and matches current query
                _this$state = this.state, data = _this$state.data, generatedForQuery = _this$state.generatedForQuery;
                searchState = this.props.searchState;
                hasVisibleContent = data && data.replace(/<[^>]*>/g, '').trim().length > 0; // Only setup once per content session - prevent infinite loop

                if (hasVisibleContent && generatedForQuery === searchState.query && !this.readTimeSetupStarted) {
                  this.readTimeSetupStarted = true; // Clean up old timer and setup new one

                  this.cleanupReadTimeTracking();
                  this.setupReadTimeTracking();
                }

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Mark component as unmounted to prevent setState in callbacks
      this.isMounted = false; // Clean up read time tracking on unmount

      this.cleanupReadTimeTracking();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Mark component as mounted
      this.isMounted = true;
    }
  }, {
    key: "processResponse",
    value: function () {
      var _processResponse = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(res) {
        var finalSources, communitySources, sources, topicIdSourceMap;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.setState({
                  data: _marked.marked.parse(res.smart_response),
                  sourcesLoading: true,
                  sourcesLength: res.sources.length,
                  topicIds: res.sources.map(function (source) {
                    return source.id;
                  }).filter(function (id) {
                    return typeof id === 'number';
                  }),
                  documentIds: res.sources.map(function (source) {
                    return source.id;
                  }).filter(function (id) {
                    return typeof id === 'string';
                  }),
                  generatedForQuery: this.props.searchState.query // Track which query this data was generated for

                });
                finalSources = res.sources;
                _context5.prev = 2;
                communitySources = res.sources.filter(function (item) {
                  return ['community', 'knowledge_base'].includes(item.source);
                });

                if (!(communitySources.length > 0)) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 7;
                return _SearchService.default.fetchMetadataForTopics(communitySources, function () {}, 'smartSummary');

              case 7:
                sources = _context5.sent;
                topicIdSourceMap = sources.reduce(function (acc, source) {
                  acc[source.id] = source;
                  return acc;
                }, {});
                finalSources.forEach(function (source) {
                  source.topicInfo = topicIdSourceMap[source.id];
                });

              case 10:
                _context5.prev = 10;
                this.setState({
                  sourcesLoading: false,
                  sources: finalSources
                });
                return _context5.finish(10);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2,, 10, 13]]);
      }));

      function processResponse(_x2) {
        return _processResponse.apply(this, arguments);
      }

      return processResponse;
    }()
  }, {
    key: "stateWithGenerateButton",
    value: function stateWithGenerateButton(msg, btnText) {
      var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var askAISearchSummary = this.props.askAISearchSummary;
      return askAISearchSummary ? (0, _preact.h)("div", {
        className: "ai-answers-generate"
      }, (0, _preact.h)(_AIAnswersHeader.default, null), (0, _preact.h)("div", {
        className: "ai-answers-description"
      }, (0, _preact.h)(_phrase.default, {
        p: "search.ai.answers.getFocusedReply"
      })), (0, _preact.h)("div", {
        className: "ai-answers-spacer"
      }), (0, _preact.h)("button", {
        className: "btn-generate-summary",
        onClick: this.onGenerateClick,
        disabled: disabled
      }, (0, _preact.h)(_phrase.default, {
        p: "search.ai.answers.generateSummary"
      }))) : (0, _preact.h)("div", {
        className: "generate-answer"
      }, (0, _preact.h)("div", null, (0, _preact.h)(_phrase.default, {
        p: msg
      })), (0, _preact.h)("button", {
        className: "btn-generate",
        onClick: this.onGenerateClick,
        disabled: disabled
      }, (0, _preact.h)(_phrase.default, {
        p: btnText
      })));
    }
    /**
     * Handles click events on links within AI Answers content
     * Uses event delegation since content is rendered as HTML
     */

  }, {
    key: "renderResourcesSidebar",
    value:
    /**
     * Renders the resources sidebar with loading state and "Show all" functionality
     */
    function renderResourcesSidebar() {
      var _this2 = this;

      var _this$state2 = this.state,
          resources = _this$state2.resources,
          data = _this$state2.data,
          generatedForQuery = _this$state2.generatedForQuery,
          showAllResources = _this$state2.showAllResources,
          loading = _this$state2.loading;
      var searchState = this.props.searchState; // Show skeleton loader when:
      // - We're still loading (streaming in progress)
      // - Data was generated for current query
      // - But resources haven't arrived yet

      var isGeneratingForCurrentQuery = data && generatedForQuery === searchState.query;
      var shouldShowLoader = loading && isGeneratingForCurrentQuery && !resources; // Parse resources HTML to count and filter resource cards

      var resourcesContent = null;
      var showAllButton = null;

      if (resources) {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = resources;
        var resourceCards = tempDiv.querySelectorAll('.resource-card');
        var totalResources = resourceCards.length; // Show "Show all" button if there are more than 3 resources and not showing all

        if (totalResources > 3 && !showAllResources) {
          // Only show first 3 resources
          var visibleCards = Array.from(resourceCards).slice(0, 3);
          var limitedHTML = visibleCards.map(function (card) {
            return card.outerHTML;
          }).join('');
          resourcesContent = (0, _preact.h)("div", {
            dangerouslySetInnerHTML: {
              __html: limitedHTML
            }
          });
          showAllButton = (0, _preact.h)("button", {
            className: "btn-show-all-resources",
            onClick: function onClick() {
              _this2.trackShowAllResourcesClick();

              _this2.setState({
                showAllResources: true
              });
            }
          }, (0, _preact.h)(_phrase.default, {
            p: "search.smart.summary.showAll"
          }));
        } else {
          // Show all resources
          resourcesContent = (0, _preact.h)("div", {
            dangerouslySetInnerHTML: {
              __html: resources
            }
          });
        }
      }

      return (0, _preact.h)("div", {
        className: "answer-sidebar"
      }, (0, _preact.h)("div", {
        className: "resources-section",
        onClick: this.handleLinkClick('AI Answers Related Link Clicked', 'relatedLink', 'related_link_click')
      }, resourcesContent, showAllButton, shouldShowLoader && (0, _preact.h)("div", {
        className: "resources-loading"
      }, (0, _preact.h)("div", {
        className: "resource-skeleton"
      }, (0, _preact.h)("div", {
        className: "skeleton-title"
      }), (0, _preact.h)("div", {
        className: "skeleton-description"
      })), (0, _preact.h)("div", {
        className: "resource-skeleton"
      }, (0, _preact.h)("div", {
        className: "skeleton-title"
      }), (0, _preact.h)("div", {
        className: "skeleton-description"
      })), (0, _preact.h)("div", {
        className: "resource-skeleton"
      }, (0, _preact.h)("div", {
        className: "skeleton-title"
      }), (0, _preact.h)("div", {
        className: "skeleton-description"
      })))));
    }
  }, {
    key: "getUIState",
    value: function getUIState() {
      var _searchState$query5;

      // UI State based on priority
      // 1. Empty query (check first to prevent showing stale data)
      // 2. Data (AI summary) - BUT only if it matches current query
      // 3. Loading
      // 4. Error
      // 5. Generate button
      var _this$state3 = this.state,
          loading = _this$state3.loading,
          data = _this$state3.data,
          error = _this$state3.error,
          sources = _this$state3.sources,
          sourcesLoading = _this$state3.sourcesLoading,
          sourcesLength = _this$state3.sourcesLength,
          isExpanded = _this$state3.isExpanded,
          generatedForQuery = _this$state3.generatedForQuery;
      var _this$props2 = this.props,
          searchState = _this$props2.searchState,
          askAISearchSummary = _this$props2.askAISearchSummary; // IMPORTANT: Check empty query FIRST to prevent showing stale data when query is cleared

      if (!((_searchState$query5 = searchState.query) !== null && _searchState$query5 !== void 0 && _searchState$query5.trim())) {
        if (askAISearchSummary) {
          return (0, _preact.h)("div", {
            className: "ai-answers-empty-state"
          }, (0, _preact.h)(_AIAnswersHeader.default, null), (0, _preact.h)("span", {
            className: "ai-answers-empty-state-message"
          }, (0, _preact.h)(_phrase.default, {
            p: "search.smart.summary.enterQuery"
          })));
        }

        return (0, _preact.h)(_phrase.default, {
          p: "search.smart.summary.enterQuery"
        });
      } // Check if data exists AND it was generated for the current query
      // If query has changed since data was generated, show generate button instead
      // Show data FIRST to avoid flickering when streaming starts
      // Also ensure data has meaningful visible text (not just empty HTML wrappers)


      var hasVisibleContent = data && data.replace(/<[^>]*>/g, '').trim().length > 0;

      if (hasVisibleContent && generatedForQuery === searchState.query) {
        var _searchState$query6;

        var needsTruncation = askAISearchSummary && data.length > 500;
        var isTruncated = needsTruncation && !isExpanded;
        var displayData = isTruncated ? SmartSearchSummary.getTruncatedContent(data) : data;
        var containerClass = "answer-container ".concat(isTruncated ? 'answer-container-truncated' : 'answer-container-expanded');
        return (0, _preact.h)("div", {
          className: containerClass
        }, (0, _preact.h)("div", {
          className: "answer-wrapper",
          "aria-live": "polite"
        }, (0, _preact.h)("div", {
          className: "answer-content"
        }, askAISearchSummary && (0, _preact.h)(_AIAnswersHeader.default, {
          className: "ai-answers-header-with-content",
          title: loading ? 'Generating...' : 'AI Answers'
        }), (0, _preact.h)("div", {
          className: askAISearchSummary ? 'ai-answer' : 'answer',
          dangerouslySetInnerHTML: {
            __html: displayData
          },
          onClick: this.handleLinkClick('AI Answers Content Link Clicked', 'contentLink', 'source_click')
        }), !askAISearchSummary && !sourcesLoading && !!(sources !== null && sources !== void 0 && sources.length) && (0, _preact.h)(_Sources.default, {
          loading: sourcesLoading,
          length: sourcesLength,
          sources: sources !== null && sources !== void 0 ? sources : []
        })), askAISearchSummary && this.renderResourcesSidebar()), isTruncated && (0, _preact.h)("div", {
          className: "btn-continue-reading-container"
        }, (0, _preact.h)("button", {
          className: "btn-continue-reading",
          onClick: this.toggleExpanded
        }, (0, _preact.h)(_phrase.default, {
          p: "search.smart.summary.continueReading"
        }))), !isTruncated && searchState.query && // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        (0, _preact.h)("div", {
          onClick: this.handleFeedbackClick
        }, (0, _preact.h)(_Feedback.Feedback, {
          options: ['Inaccurate content', 'Outdated summary', 'Summary is too long', 'Complex to understand', 'Query not answered'],
          featureName: "search-summary",
          input: (_searchState$query6 = searchState.query) !== null && _searchState$query6 !== void 0 ? _searchState$query6 : '',
          output: data !== null && data !== void 0 ? data : '',
          topicIds: this.state.topicIds,
          documentIds: this.state.documentIds
        })));
      } // Show loader if still loading and no visible content yet


      if (loading && !hasVisibleContent) {
        return askAISearchSummary ? (0, _preact.h)("div", {
          className: "ai-answers-loading"
        }, (0, _preact.h)(_AIAnswersHeader.default, {
          title: "Generating..."
        })) : (0, _preact.h)(_Loading.default, {
          "data-testid": "loading"
        });
      } // Check if we should disable the generate button:
      // - If we're currently loading (have data but still streaming)
      // - AND the query hasn't changed (generatedForQuery matches current query)


      var shouldDisableButton = loading && generatedForQuery === searchState.query;
      if (error) return this.stateWithGenerateButton(error, 'Retry', shouldDisableButton);
      return this.stateWithGenerateButton('search.smart.summary.generateSummary', 'search.smart.summary.generate', shouldDisableButton);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          hidden = _this$props3.hidden,
          askAISearchSummary = _this$props3.askAISearchSummary;
      return (0, _preact.h)("div", {
        className: askAISearchSummary ? 'ai-answers-summary' : 'smart-summary',
        hidden: hidden
      }, !askAISearchSummary && (0, _preact.h)("div", {
        className: "heading"
      }, (0, _preact.h)(_phrase.default, {
        p: "search.smart.summary.smartAssistant"
      })), (0, _preact.h)("div", {
        className: "content"
      }, this.getUIState()));
    }
  }], [{
    key: "formatResponse",
    value: // Helper function to format the response with proper styling
    function formatResponse(conversationalText, fullResponse) {
      // Store both conversational text and resources separately
      var formattedHTML = conversationalText ? _marked.marked.parse(conversationalText) : ''; // Return an object with both parts

      return {
        conversationalText: formattedHTML,
        resources: fullResponse
      };
    }
  }, {
    key: "getTruncatedContent",
    value: function getTruncatedContent(html) {
      // Simple truncation - extract first few paragraphs or first ~3000 characters
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = html; // Get all paragraph elements

      var paragraphs = tempDiv.querySelectorAll('p, h1, h2, h3, h4, h5, h6, ul, ol');

      if (paragraphs.length === 0) {
        // If no structured content, just truncate by character count
        return html.substring(0, 3000) + '...';
      } // Take first 2-3 elements (or until we reach ~3000 characters)


      var truncatedHTML = '';
      var charCount = 0;
      var maxChars = 3000;
      var maxElements = 6;

      for (var i = 0; i < Math.min(paragraphs.length, maxElements); i++) {
        var _element$textContent;

        var element = paragraphs[i];
        var elementText = (_element$textContent = element.textContent) !== null && _element$textContent !== void 0 ? _element$textContent : '';

        if (charCount + elementText.length > maxChars && i > 0) {
          break;
        }

        truncatedHTML += element.outerHTML;
        charCount += elementText.length;
      }

      return truncatedHTML || html.substring(0, 3000) + '...';
    }
  }]);
  return SmartSearchSummary;
}(_preactCompat.PureComponent);

var _default = (0, _connectors.connectStateResults)(SmartSearchSummary);

exports.default = _default;